import http from '@/config/http'

export default {
  detail (params) {
    return http.get(
      `${process.env.VUE_APP_PREFIX}/1.0/Search/OutSearchByKeyWord`,
      {
        params: params
      }
    )
  }
}
